var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.2")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 200.27 202.34)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,35,35)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256.7, -262)",
    d: "M 472.7 45 h -432 C 19 45 1.4 62.6 1.4 84.3 v 355.4 C 1.4 461.4 19 479 40.7 479 h 432 c 21.7 0 39.3 -17.6 39.3 -39.3 V 84.3 C 512 62.6 494.4 45 472.7 45 z M 492.8 439.7 c 0 11.1 -9 20.1 -20.1 20.1 h -432 c -11.1 0 -20.1 -9 -20.1 -20.1 V 84.3 c 0 -11.1 9 -20.1 20.1 -20.1 h 432 c 11.1 0 20.1 9 20.1 20.1 V 439.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 154.71 174.88)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,35,35)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.05, -191.7)",
    d: "M 140.1 240.6 c 26.9 0 48.9 -21.9 48.9 -48.9 s -21.9 -48.9 -48.9 -48.9 c -8.6 0 -17.1 2.3 -24.6 6.6 c -4.6 2.7 -6.1 8.5 -3.5 13.1 c 2.7 4.6 8.6 6.1 13.1 3.5 c 4.5 -2.6 9.7 -4 14.9 -4 c 16.4 0 29.7 13.3 29.7 29.7 s -13.3 29.7 -29.7 29.7 s -29.7 -13.3 -29.7 -29.7 c 0 -2.9 0.4 -5.9 1.3 -8.7 c 1.5 -5.1 -1.3 -10.4 -6.4 -12 c -5 -1.6 -10.4 1.3 -12 6.4 c -1.4 4.6 -2.1 9.4 -2.1 14.3 C 91.2 218.7 113.1 240.6 140.1 240.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 195.98 219.1)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,35,35)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-245.71, -304.9)",
    d: "M 325.1 216 c -3.8 -3.5 -9.7 -3.5 -13.4 0.2 l -74.5 74.5 L 214 267.4 c -1.8 -1.8 -4.2 -2.8 -6.8 -2.8 c 0 0 0 0 0 0 c -2.6 0 -5 1 -6.8 2.8 L 89 380 c -3.7 3.8 -3.7 9.8 0.1 13.6 c 1.9 1.8 4.3 2.8 6.8 2.8 c 2.5 0 4.9 -0.9 6.8 -2.8 l 104.6 -105.7 l 42.8 42.8 c 3.7 3.7 9.8 3.7 13.6 0 c 3.7 -3.7 3.7 -9.8 0 -13.6 l -12.7 -12.7 l 67.9 -67.9 l 70.1 65.9 c 3.9 3.6 9.9 3.4 13.6 -0.4 c 3.6 -3.9 3.4 -9.9 -0.4 -13.6 L 325.1 216 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.39 0 0 0.39 265.21 225.5)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,35,35)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-422.95, -321.29)",
    d: "M 425.2 310.2 c -3.9 -3.6 -9.9 -3.5 -13.6 0.4 c -3.6 3.9 -3.4 9.9 0.4 13.6 l 8.7 8.2 c 1.9 1.7 4.2 2.6 6.6 2.6 c 2.5 0 5.1 -1 7 -3 c 3.6 -3.9 3.4 -9.9 -0.4 -13.6 L 425.2 310.2 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.ef03bf631704aa56734215333d993bb7.svg";
export { ForwardRef as ReactComponent };